import React, { useEffect, useState } from 'react'
import Banner from './Banner';
import { ReactComponent as InfoIcon } from '../../assets/plus_icon/incentive_pending.svg';
import { ReactComponent as ScanIcon } from '../../assets/plus_icon/scan.svg';
import { ReactComponent as LeftArrowIcon } from '../../assets/plus_icon/leftArrow.svg';
import BrokerCodeModal from './Modal/BrokerCodeModal';
import GetBrokerCodeModal from './Modal/GetBrokerCodeModal';
import BorkerQRCode from './Modal/BorkerQRCode';
import PhoneInput from 'react-phone-input-2';
import InputSelect from '../../components/InputGroup/InputSelect';
import Select from 'react-select';
import { ReactComponent as RightIcon } from '../../assets/righticon.svg'
import { checkBrokerInCompany, searchCpFirms, checkExecMobileByFirmUUID } from '../../services/private/site-visit.service';
import AsyncSelect from 'react-select/async';
// import { ReactComponent as LeftArrowIcon } from '../../assets/plus_icon/leftArrow.svg';
import { toast } from 'react-toastify';
import { ReactComponent as RefreshIcon } from '../../assets/plus_icon/refresh.svg';
import 'react-phone-input-2/lib/style.css'
import { resolveSourcingManagerOption, isSourcingManagerValid } from './sourcingManagerUtils';

const customStyles = {
    control: (base, state) => ({
        ...base,
        boxShadow: "none",
        borderColor: '#ced4da',
        // backgroundColor: '#FAFAFB',
        minHeight: '44px',
        height: '44px',
        '@media (min-width: 640px)': {
            minHeight: '54px',
            height: '54px',
        },
        minWidth: '100%',
        borderRadius: '12px',
        fontSize: '16px',
        fontWeight: '400',
        cursor: 'pointer',
        '&:focus': { borderColor: '#0062ff' },
    }),
    option: (styles, state) => ({
        ...styles,
        fontSize: '14px',
        cursor: 'pointer',
        borderBottom: '1px solid #E5E7EB',
        backgroundColor: state.isSelected ? "#f1f1f5" : styles.color,
        color: '#44444f',
        zIndex: 99,
        "&:hover": {
            color: "#44444f",
            backgroundColor: "#f1f1f5"
        },
        "&:last-child": {
            borderBottom: "none"
        }
    }),
};
const mobileCustomStyles = {
    control: (base, state) => ({
        ...base,
        boxShadow: "none",
        borderColor: '#ced4da',
        // backgroundColor: '#FAFAFB',
        minHeight: '38px',
        minWidth: '100%',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: '400',
        cursor: 'pointer',
        '&:focus': { borderColor: '#0062ff' },
    }),
    option: (styles, state) => ({
        ...styles,
        fontSize: '14px',
        cursor: 'pointer',
        borderBottom: '1px solid #E5E7EB',
        backgroundColor: state.isSelected ? "#f1f1f5" : styles.color,
        color: '#44444f',
        zIndex: 99,
        "&:hover": {
            color: "#44444f",
            backgroundColor: "#f1f1f5"
        },
        "&:last-child": {
            borderBottom: "none"
        }
    }),
};

const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    const itemData = data?.data || {};
    const isContact = itemData.type === 'contact';
    const displayName = itemData.name || '';
    const ownerName = itemData.owner_name || '';
    const rawMobile = itemData.mobile || itemData.owner_mobile || '';
    const isVerified = itemData.is_verified === true;

    const maskMob = (mob) => {
        if (!mob) return '';
        const clean = mob.toString().replace(/\D/g, '');
        if (clean.length < 4) return mob;
        return `(XXXXXXX${clean.slice(-4)})`;
    };

    const maskedMob = maskMob(rawMobile);
    const desktopOwnerText = [ownerName, maskedMob].filter(Boolean).join(' ');
    const mobileOwnerText = [ownerName, maskedMob].filter(Boolean).join(' ');
    const mobileSubtitle = mobileOwnerText ? `Owner: ${mobileOwnerText}` : '';

    return (
        <div ref={innerRef} {...innerProps} className={`w-full flex justify-between items-center text-xs sm:text-sm py-2 px-3 gap-2 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors ${props.isSelected ? 'bg-blue-50/70' : ''}`}>
            <div className='flex items-center gap-2 min-w-0 flex-1'>
                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider flex-shrink-0 ${
                    isContact ? 'bg-gray-100 text-gray-500' : 'bg-blue-50 text-[#0062FF]'
                }`}>
                    {isContact ? 'CONTACT' : 'FIRM'}
                </span>
                <div className="flex flex-col sm:flex-row sm:items-center min-w-0 flex-1 gap-0.5 sm:gap-2">
                    <span className='font-semibold text-gray-800 truncate'>
                        {displayName}
                    </span>
                    {!isContact && mobileSubtitle && (
                        <span className="sm:hidden text-[11px] text-gray-400 font-normal truncate">
                            {mobileSubtitle}
                        </span>
                    )}
                </div>
            </div>

            <div className='flex items-center gap-1.5 flex-shrink-0 text-right my-auto'>
                {isContact ? (
                    <span className='text-xs sm:text-sm text-gray-500 font-medium truncate max-w-[150px] italic whitespace-nowrap'>
                        {itemData.company_name || itemData.firm_name || 'No firm on file'}
                    </span>
                ) : (
                    <div className='flex items-center gap-1.5'>
                        {desktopOwnerText && (
                            <span className='hidden sm:inline-block text-xs sm:text-sm text-gray-500 font-medium whitespace-nowrap'>
                                {desktopOwnerText}
                            </span>
                        )}
                        {isVerified ? (
                            <span className="w-4 h-4 rounded-full bg-[#01AC47] text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0" title="Verified Firm">
                                ✓
                            </span>
                        ) : (
                            <span className="w-4 h-4 rounded-full bg-[#FC5A5A] text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0" title="Unverified Firm">
                                ✕
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

const CustomNoOptionsMessage = (props) => {
    return (
        <div className='flex flex-col'>
            <div className='text-gray-400 py-3 px-3 text-sm text-center'>No matches</div>
            <div
                className='text-blue-600 hover:text-blue-800 font-semibold py-3 px-4 text-sm border-t border-gray-100 cursor-pointer flex justify-between items-center bg-blue-50/50 hover:bg-blue-50 transition-colors'
                onMouseDown={(e) => {
                    e.preventDefault();
                    if (props.selectProps.onCustomFallbackClick) {
                        props.selectProps.onCustomFallbackClick();
                    }
                }}
            >
                <span>Couldn't Find Your Company?</span>
                <span className='font-bold text-base'>&gt;</span>
            </div>
        </div>
    );
};

const BorkerDetailForm = ({ setChannelPartner, isWithCP, isCPVisit, brokerCode, setBrokerCode, brokerName, brokerMobile, companyId, setBrokerName, setBrokerMobile, setNewBrokerName, setNewBrokerMobile, setCompanyId, coverImage, projectName, rera, setRera, setOwnerName, setOwnerMobile, setCompanyName, cpContactUuid, setCpContactUuid, setIsReraUpdated, setPreviousStepBeforeCapture, sourcingManager, setSourcingManager, sourcingManagerSource, setSourcingManagerSource, allSourcingManagers, fetchSourcingManagers, isSourcingRefreshing, isRevisit, projectId }) => {

    const [showBrokerCodeModal, setShowBrokerCodeModal] = useState(false);
    const [showQRCodeModal, setShowQRCodeModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [name, setName] = useState('')
    const [mobile, setMobile] = useState('')
    const [error, setError] = useState(false);
    const [userNotFound, setUserNotFound] = useState(false);
    const [mobileError, setMobileError] = useState(false);
    const [isVerifiedUser, setIsVerifiedUser] = useState(false);
    const [isReadonlyName, setIsReadonlyName] = useState(false);
    const [reraDuplicateError, setReraDuplicateError] = useState('');
    const [showReraModal, setShowReraModal] = useState(false);
    const [reraModalFirmName, setReraModalFirmName] = useState('');
    const [initialRera, setInitialRera] = useState('');
    const [showReraConfirmModal, setShowReraConfirmModal] = useState(false);
    const reraInputRef = React.useRef(null);
    const [showStickyOption, setShowStickyOption] = useState(false);
    const [firmList, setFirmList] = useState([]);
    const [companySearchText, setCompanySearchText] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const companyFieldRef = React.useRef(null);

    const clearCpFirmSourcingManager = () => {
        if (sourcingManagerSource === 'cp_firm') {
            setSourcingManager?.(null);
            setSourcingManagerSource?.(null);
        }
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (companyFieldRef.current && !companyFieldRef.current.contains(e.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (companyId) {
            const labelText = typeof companyId === 'object' ? (companyId.label || companyId.data?.name || companyId.data?.company_name || '') : '';
            if (labelText) {
                setCompanySearchText(labelText);
            }
        } else {
            setCompanySearchText('');
        }
    }, [companyId]);

    const latestSearchQueryRef = React.useRef('');
    const searchCounterRef = React.useRef(0);

    const maskMobile = (mob) => {
        if (!mob) return '';
        const clean = mob.toString().replace(/\D/g, '');
        if (clean.length < 4) return mob;
        const last4 = clean.slice(-4);
        return `(XXXXXXX${last4})`;
    };

    const [isLoadingCompanies, setIsLoadingCompanies] = useState(false);
    const searchDebounceTimeoutRef = React.useRef(null);

    const getCompany = (company) => {
        const queryText = (company || '').trim();
        latestSearchQueryRef.current = queryText;

        if (searchDebounceTimeoutRef.current) {
            clearTimeout(searchDebounceTimeoutRef.current);
        }

        setIsLoadingCompanies(true);

        searchDebounceTimeoutRef.current = setTimeout(async () => {
            searchCounterRef.current += 1;
            const currentReqId = searchCounterRef.current;

            try {
                const res = await searchCpFirms(queryText, projectId);
                // Ignore stale API response if user has typed a newer query in the meantime
                if (currentReqId !== searchCounterRef.current) {
                    return;
                }

                if (res?.data?.status === 200) {
                    const rawList = res.data.data.results || [];
                    console.log('--- DB Search API Response Results ---', rawList);
                    setFirmList(rawList);
                    setShowStickyOption(rawList.length === 0);
                }
            } catch (err) {
                if (currentReqId === searchCounterRef.current) {
                    console.error('Error fetching companies:', err);
                    setFirmList([]);
                    setShowStickyOption(true);
                }
            } finally {
                if (currentReqId === searchCounterRef.current) {
                    setIsLoadingCompanies(false);
                }
            }
        }, 250);
    };

    const renderFirmRow = (item) => {
        const isContact = item.type === 'contact';
        const displayName = item.name || '';
        const ownerName = item.owner_name || '';
        const rawMobile = item.mobile || item.owner_mobile || '';
        const maskedMob = maskMobile(rawMobile);
        
        // Determine verification status strictly from is_verified key
        const isVerified = item.is_verified === true;

        const desktopOwnerText = [ownerName, maskedMob].filter(Boolean).join(' ');
        const mobileOwnerText = [ownerName, maskedMob].filter(Boolean).join(' ');
        const mobileSubtitle = mobileOwnerText ? `Owner: ${mobileOwnerText}` : '';

        return (
            <div
                key={item.id || item.uuid || item.name}
                className="px-3.5 py-2.5 hover:bg-gray-50 cursor-pointer flex justify-between items-center text-xs sm:text-sm gap-2 transition-colors"
                onMouseDown={(e) => {
                    e.preventDefault();
                    const formattedOption = {
                        label: displayName,
                        value: item.id,
                        data: item
                    };
                    setCompanySearchText(displayName);
                    handleCompanyChange(formattedOption);
                    setIsDropdownOpen(false);
                }}
            >
                <div className="flex items-center gap-2 min-w-0 flex-1">
                    <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider flex-shrink-0 ${
                        isContact ? 'bg-gray-100 text-gray-500' : 'bg-blue-50 text-[#0062FF]'
                    }`}>
                        {isContact ? 'CONTACT' : 'FIRM'}
                    </span>
                    <div className="flex flex-col sm:flex-row sm:items-center min-w-0 flex-1 gap-0.5 sm:gap-2">
                        <span className="font-semibold text-gray-800 truncate">
                            {displayName}
                        </span>
                        {!isContact && mobileSubtitle && (
                            <span className="sm:hidden text-[11px] text-gray-400 font-normal truncate">
                                {mobileSubtitle}
                            </span>
                        )}
                    </div>
                </div>

                <div className="flex items-center gap-1.5 flex-shrink-0 text-right my-auto">
                    {isContact ? (
                        <span className="text-xs sm:text-sm text-gray-500 font-medium truncate max-w-[150px] italic whitespace-nowrap">
                            {item.company_name || item.firm_name || 'No firm on file'}
                        </span>
                    ) : (
                        <div className="flex items-center gap-1.5">
                            {desktopOwnerText && (
                                <span className="hidden sm:inline-block text-xs sm:text-sm text-gray-500 font-medium whitespace-nowrap">
                                    {desktopOwnerText}
                                </span>
                            )}
                            {isVerified ? (
                                <span className="w-4 h-4 rounded-full bg-[#01AC47] text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0" title="Verified Firm">
                                    ✓
                                </span>
                            ) : (
                                <span className="w-4 h-4 rounded-full bg-[#FC5A5A] text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0" title="Unverified Firm">
                                    ✕
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const checkReraDuplicate = async (val, currentCompany) => {
        if (!val || !val.trim()) {
            setReraDuplicateError('');
            setReraModalFirmName('');
            return;
        }
        const currentCompData = currentCompany?.data || {};
        const originalRera = currentCompData.rera_number || currentCompData.rera || '';

        // If selected company's original auto-filled RERA is unchanged, no error
        if (originalRera && originalRera.trim().toLowerCase() === val.trim().toLowerCase()) {
            setReraDuplicateError('');
            setReraModalFirmName('');
            return;
        }

        try {
            const res = await searchCpFirms(val.trim());
            if (res?.data?.status === 200) {
                const searchResults = res.data?.data?.results || [];
                const dup = searchResults.find(f => {
                    if (f.type === 'contact') return false;
                    const isSameCompany = (currentCompany?.value && f.id === currentCompany.value) ||
                                          (currentCompData.uuid && f.uuid === currentCompData.uuid);
                    if (isSameCompany) return false;

                    const reraVal = f.rera_number || f.rera;
                    return reraVal && reraVal.toString().trim().toLowerCase() === val.trim().toLowerCase();
                });

                if (dup) {
                    const dupName = dup.name || dup.company_name || 'another firm';
                    setReraDuplicateError(`This RERA number is already registered to ${dupName}.`);
                    setReraModalFirmName(dupName);
                } else {
                    setReraDuplicateError('');
                    setReraModalFirmName('');
                }
            }
        } catch (err) {
            console.error('Error checking RERA duplicate against database:', err);
        }
    };

    const handleReraBlur = () => {
        if (reraDuplicateError && reraModalFirmName) {
            setShowReraModal(true);
        }
    };

    const closeReraModal = () => {
        setShowReraModal(false);
        if (setRera) setRera('');
        setReraDuplicateError('');
        setReraModalFirmName('');
        if (reraInputRef.current) {
            reraInputRef.current.focus();
        }
    };

    const handleCompanyChange = (selected) => {
        setCompanyId(selected);
        setReraDuplicateError('');
        if (!selected) {
            if (setRera) setRera('');
            setInitialRera('');
            if (setIsReraUpdated) setIsReraUpdated(false);
            if (setCpContactUuid) setCpContactUuid(null);
            if (setBrokerName) setBrokerName('');
            setBrokerMobile('');
            setIsVerifiedUser(false);
            setUserNotFound(false);
            setIsReadonlyName(false);
            // If sourcing manager was prefilled from CP firm, reset it upon unselecting the firm
            clearCpFirmSourcingManager();
            return;
        }

        const compData = selected.data || {};
        if (compData.type === 'contact') {
            setInitialRera('');
            if (setIsReraUpdated) setIsReraUpdated(false);
            const rawMob = (compData.mobile || compData.owner_mobile || '').toString().replace(/\D/g, '');
            const clean10Digits = rawMob.length > 10 ? rawMob.slice(-10) : rawMob;
            const fullMob = clean10Digits ? `91${clean10Digits}` : '91';
            
            setCompanyName?.(compData.company_name || compData.firm_name || '');
            setRera?.(compData.rera_number || compData.rera || '');
            
            // Prefill Executive fields for BrokerRegistration (Step 8)
            setNewBrokerName?.(compData.name || '');
            setNewBrokerMobile?.(fullMob);
            setBrokerName?.(compData.name || '');
            setBrokerMobile?.(fullMob);
            
            // Reset Owner fields initially so user/toggle drives them
            setOwnerName?.('');
            setOwnerMobile?.('91');

            setCpContactUuid?.(compData.uuid || null);
            // Leaving CP firm for individual contact: clear firm sourcing manager
            clearCpFirmSourcingManager();
            setChannelPartner('8');
            return;
        }

        if (setCpContactUuid) setCpContactUuid(null);
        const reraVal = compData.rera_number || compData.rera || '';
        setInitialRera(reraVal || '');
        if (setIsReraUpdated) setIsReraUpdated(false);
        if (setRera) {
            setRera(reraVal);
            // Selecting firm auto-fills its RERA, so duplicate error should be clear
            setReraDuplicateError('');
        }

        // const selectedFirmName = selected.label || compData.name || 'Company';
        // toast.success(`You have selected ${selectedFirmName}`, {
        //     position: 'bottom-center',
        //     autoClose: 2500,
        //     toastId: 'firm-select-toast'
        // });

        // Prefill Sourcing Manager from picked CP if source is not 'lead' and not 'manual' (Backend Doc Section 3 & Notes)
        const cpSM = compData.sourcing_manager;
        if (sourcingManagerSource !== 'lead' && sourcingManagerSource !== 'manual') {
            if (cpSM && (cpSM.id || cpSM.name || cpSM.uuid)) {
                const opt = resolveSourcingManagerOption(cpSM, allSourcingManagers);
                setSourcingManager?.(opt);
                setSourcingManagerSource?.('cp_firm');
            } else if (sourcingManagerSource === 'cp_firm') {
                // If previous firm had SM, but this new firm has none, clear it
                setSourcingManager?.(null);
                setSourcingManagerSource?.(null);
            }
        }
    };

    const handleMobileChange = (phone) => {
        // Prevent total wipe of country code prefix so PhoneInput UI does not freeze or lose flag/prefix
        const finalValue = !phone || phone.trim() === '' ? '91' : phone;
        setBrokerMobile(finalValue);
        const digits = phone ? phone.replace(/\D/g, '') : '';
        const clean10Digits = digits.length > 10 ? digits.slice(-10) : digits;

        if (clean10Digits.length < 10) {
            setIsVerifiedUser(false);
            setUserNotFound(false);
            if (isReadonlyName) {
                setBrokerName('');
                setIsReadonlyName(false);
            }
            return;
        }

        const compData = companyId?.data || {};
        const ownerMobile = compData.mobile || compData.owner_mobile || '';
        const cleanOwnerDigits = ownerMobile ? ownerMobile.replace(/\D/g, '').slice(-10) : '';

        // 1. Check if input mobile matches the Firm's Owner Mobile first
        if (cleanOwnerDigits && cleanOwnerDigits === clean10Digits) {
            setIsVerifiedUser(true);
            setUserNotFound(false);
            const ownerName = compData.owner_name || compData.name || '';
            if (ownerName && setBrokerName) {
                setBrokerName(ownerName);
                setIsReadonlyName(true);
            }
            return;
        }

        // 2. Otherwise, check Executive verification API
        const runVerification = (firmUuid, mobileNum) => {
            checkExecMobileByFirmUUID(firmUuid, mobileNum).then(res => {
                if (res?.data?.status === 200 || res?.status === 200) {
                    const verifyData = res.data?.data || res.data || {};
                    if (verifyData.found) {
                        setIsVerifiedUser(true);
                        setUserNotFound(false);
                        if (setBrokerName) setBrokerName(verifyData.name || '');
                        setIsReadonlyName(true);
                    } else {
                        setIsVerifiedUser(false);
                        setUserNotFound(true);
                        setIsReadonlyName(false);
                    }
                }
            }).catch(err => {
                console.error('Error verifying exec mobile:', err);
                setIsVerifiedUser(false);
                setUserNotFound(true);
                setIsReadonlyName(false);
            });
        };

        const targetFirmUuid = compData.uuid || compData.firm_uuid || companyId?.value;
        if (targetFirmUuid) {
            runVerification(targetFirmUuid, clean10Digits);
        } else {
            setIsVerifiedUser(false);
            setUserNotFound(false);
        }
    };

    const handleFallbackClick = () => {
        setBrokerName('');
        setBrokerMobile('');
        setCompanyId('');
        if (setCompanyName) {
            setCompanyName(companySearchText);
        }
        if (setCpContactUuid) {
            setCpContactUuid(null);
        }
        // Registering new firm: clear any previous CP firm's sourcing manager
        clearCpFirmSourcingManager();
        setChannelPartner('8');
    };

    const handleSubmit = async () => {
        if (reraDuplicateError) {
            toast.error(reraDuplicateError || 'This RERA number is already registered to another firm.', {
                toastId: 'rera-dup-error'
            });
            return;
        }
        const isCompanySelected = Boolean(companyId && typeof companyId === 'object' ? companyId.value : companyId);
        const cleanMobileDigits = brokerMobile ? brokerMobile.replace(/\D/g, '').slice(-10) : '';
        const isMobileValid = cleanMobileDigits.length === 10;

        if (!brokerName || !isMobileValid || !isCompanySelected || !rera || !rera.trim()) {
            setError(true);
            if (!isCompanySelected) {
                toast.error('Please select a CP Firm from search results.', { toastId: 'company-req-error' });
            } else if (!rera || !rera.trim()) {
                toast.error('Please enter a valid RERA number.', { toastId: 'rera-req-error' });
            }
            return;
        } else {
            setError(false);
        }
        if (cleanMobileDigits.length < 10) {
            setMobileError(true);
            return;
        } else {
            setMobileError(false)
        }
        const proceedSubmission = async () => {
            if (isCPVisit) {
                if (setNewBrokerName) setNewBrokerName(brokerName);
                if (setNewBrokerMobile) setNewBrokerMobile(brokerMobile);
            }
            if (setPreviousStepBeforeCapture) {
                setPreviousStepBeforeCapture('4');
            }
            if (userNotFound) {
                toast.info('New user — will be added to this firm', {
                    position: 'bottom-center',
                    autoClose: 3000,
                    toastId: 'new-user-toast'
                });
            }
            const payload = {
                broker_mobile: brokerMobile,
                broker_company_id: (cpContactUuid || companyId?.data?.type === 'contact') ? null : (companyId?.value || null),
                rera_number: rera || null
            }
            try {
                const res = await checkBrokerInCompany(payload);
                if (res.data.status === 200 || res?.status === 200) {
                    setChannelPartner('5');
                } else {
                    setChannelPartner('5');
                }
            } catch (err) {
                if (err?.response?.status === 409) {
                    setReraDuplicateError(err.response.data || 'A CP Firm with this RERA number already exists.');
                } else if (err?.response?.data?.status === 404 || err?.response?.status === 404) {
                    setUserNotFound(true);
                    toast.info('New user — will be added to this firm', {
                        position: 'bottom-center',
                        autoClose: 3000,
                        toastId: 'new-user-toast'
                    });
                    setChannelPartner('5');
                } else {
                    setChannelPartner('5');
                }
            }
        };

        const currentCompData = companyId?.data || {};
        const isExistingFirm = currentCompData.type !== 'contact' && Boolean(companyId?.value);
        const isReraModified = isExistingFirm && Boolean(initialRera) && (rera || '').trim().toLowerCase() !== initialRera.trim().toLowerCase();

        if (isReraModified && !showReraConfirmModal) {
            setShowReraConfirmModal(true);
            return;
        }

        setShowReraConfirmModal(false);
        await proceedSubmission();
    }

    return (
        <div className=' mx-auto overflow-auto h-100'>
            <div className='!w-full broker-info'>
                <Banner coverImage={coverImage} projectName={projectName} />
            </div>
            <div className='bg-white overflow-y-auto md:overflow-hidden rounded-xl !my-3 sm:!my-6 !p-4 md:!p-12 !pb-24 sm:!pb-32 space-y-4 md:space-y-6 animate-in fade-in-90 slide-in-from-top-2 duration-300 ease-out transition-all origin-top'>
                <div className='flex items-center justify-center relative border-b border-gray-100 !pb-4 sm:!pb-6 !mb-2'>
                    <button className='flex items-center absolute left-0 text-gray-700 hover:text-black font-medium text-sm sm:text-base cursor-pointer' onClick={() => {
                        if (setCompanyId) setCompanyId('');
                        if (setBrokerName) setBrokerName('');
                        if (setBrokerMobile) setBrokerMobile('91');
                        if (setRera) setRera('');
                        if (setOwnerName) setOwnerName('');
                        if (setOwnerMobile) setOwnerMobile('91');
                        if (setCompanyName) setCompanyName('');
                        if (setCpContactUuid) setCpContactUuid(null);
                        if (isCPVisit) {
                            if (setNewBrokerName) setNewBrokerName('');
                            if (setNewBrokerMobile) setNewBrokerMobile('');
                            setChannelPartner('2');
                        } else {
                            clearCpFirmSourcingManager();
                            setChannelPartner('3');
                        }
                    }}>
                        <LeftArrowIcon className='stroke-black800 rotate-180 mr-1.5 w-4 h-4 sm:w-5 sm:h-5' /> <span className='hidden sm:inline-block'>Back</span>
                    </button>
                    <p className='flex flex-col mb-0 text-center'>
                        <span className='text-lg sm:text-xl font-medium'>Fill Channel Partner Details - <span className='text-[#2064FA]'>{projectName || 'Krystal One'}</span> </span>
                    </p>
                </div>
                <div className='w-full flex flex-col sm:space-x-6'>
                    {/* ========================================================================= */}
                    {/* OLD REACT-SELECT ASYNCSELECT IMPLEMENTATION (COMMENTED FOR BACKUP)        */}
                    {/* ========================================================================= */}
                    {/*
                    <div className={`flex-col font-medium relative w-full hidden sm:flex`}>
                        <label className='sm:!text-lg text-base !mb-3 '>CP Company<sup className='text-red'>*</sup></label>
                        <AsyncSelect
                            cacheOptions={false}
                            loadOptions={getCompany}
                            defaultOptions
                            placeholder='Search and Select Company'
                            styles={customStyles}
                            value={companyId}
                            onChange={(selected) => {
                                handleCompanyChange(selected);
                                setCompanySearchText(selected ? selected.label : '');
                            }}
                            isClearable={false}
                            isSearchable={true}
                            inputValue={companySearchText}
                            onInputChange={(val, actionMeta) => {
                                if (actionMeta.action === 'input-change') {
                                    setCompanySearchText(val);
                                    if (companyId && val !== companyId.label) {
                                        handleCompanyChange(null);
                                    }
                                } else if (actionMeta.action === 'set-value') {
                                    setCompanySearchText(val);
                                }
                            }}
                            onMenuOpen={() => {
                                if (companySearchText) {
                                    getCompany(companySearchText);
                                } else {
                                    getCompany('');
                                }
                            }}
                            menuPosition={'fixed'}
                            components={{ Option: CustomOption, NoOptionsMessage: CustomNoOptionsMessage }}
                            onCustomFallbackClick={handleFallbackClick}
                        />
                    </div>
                    */}

                    {/* ========================================================================= */}
                    {/* NEW CUSTOM COMBOBOX IMPLEMENTATION (MATCHING tablet_form_cp_flow_mockup.html) */}
                    {/* ========================================================================= */}
                    <div className="flex flex-col font-medium relative w-full" id="companyFieldWrap" ref={companyFieldRef}>
                        <label className="sm:!text-lg text-base !mb-2">Search using company name / RERA <sup className="text-red-500">*</sup></label>
                        <div className="relative w-full">
                            <input
                                type="text"
                                className="border border-gray-300 rounded-xl focus:outline-none focus:border-[#0062ff] text-input sm:!text-lg text-sm !py-2 !px-3 sm:!py-3 sm:!px-4 w-full pr-9 font-normal text-gray-800"
                                placeholder="Search using company name / RERA"
                                autoComplete="off"
                                value={companySearchText}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setCompanySearchText(val);
                                    if (companyId && val !== companyId.label) {
                                        handleCompanyChange(null);
                                    }
                                    getCompany(val);
                                    setIsDropdownOpen(true);
                                }}
                                onFocus={() => {
                                    getCompany(companySearchText || '');
                                    setIsDropdownOpen(true);
                                }}
                            />
                            <span className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-xs">
                                &#9662;
                            </span>

                            {isDropdownOpen && (
                                <div className="absolute left-0 right-0 top-[calc(100%+4px)] border border-gray-200 rounded-xl shadow-xl bg-white z-[999] overflow-hidden">
                                    <div className="max-h-[170px] overflow-y-auto divide-y divide-gray-100">
                                        {firmList && firmList.length > 0 ? (
                                            firmList.map((item) => renderFirmRow(item))
                                        ) : !isLoadingCompanies ? (
                                            <div className="py-3 px-3 text-sm text-gray-400 text-center">
                                                No matches
                                            </div>
                                        ) : null}
                                    </div>

                                    {/* Sticky Row Fallback: Couldn't Find Your Company? (Only shown when not loading AND no matches found) */}
                                    {!isLoadingCompanies && (!firmList || firmList.length === 0) && (
                                        <div
                                            className="text-blue-600 hover:text-blue-800 font-semibold py-3 px-4 text-sm border-t border-gray-100 cursor-pointer flex justify-between items-center bg-blue-50/40 hover:bg-blue-50 transition-colors"
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                setIsDropdownOpen(false);
                                                handleFallbackClick();
                                            }}
                                        >
                                            <span>Couldn't Find Your Company?</span>
                                            <span className="font-bold text-base">&rsaquo;</span>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    {error && !companyId?.value && (
                        <div className="text-red sm:!text-sm text-xs font-medium !mt-2 !ml-0">Please Select Company.</div>
                    )}
                </div>

                {/* RERA Number Input Field (Full Width when company is selected) */}
                {companyId?.value && (
                    <div className='w-full flex flex-col font-medium relative'>
                        <label className='sm:!text-lg text-base !mb-2'>RERA Number <sup className='text-red'>*</sup></label>
                        <input
                            ref={reraInputRef}
                            className={`border rounded-xl focus:outline-none focus:!border-primary text-input sm:!text-lg text-sm !py-2 !px-3 sm:!py-3 sm:!px-4 font-normal text-gray-800 ${
                                reraDuplicateError ? 'border-red-500' : 'border-gray-300'
                            }`}
                            type="text"
                            name="rera"
                            value={rera || ''}
                            onChange={(e) => {
                                const val = e.target.value;
                                setRera && setRera(val);
                                const isModified = Boolean(initialRera) && val.trim().toLowerCase() !== initialRera.trim().toLowerCase();
                                if (setIsReraUpdated) setIsReraUpdated(isModified);
                                checkReraDuplicate(val, companyId);
                            }}
                            onBlur={handleReraBlur}
                            placeholder="Enter RERA Number"
                        />
                        {reraDuplicateError && (
                            <div className="text-red sm:!text-sm text-xs font-medium !mt-1">{reraDuplicateError}</div>
                        )}
                    </div>
                )}

                {/* Executive Name & Executive Mobile Row */}
                <div className='w-full flex flex-col sm:flex-row items-start space-y-4 sm:space-y-0 sm:space-x-6'>
                    <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>Executive Name<sup className='text-red'>*</sup></label>
                        <input
                            className={`border rounded-xl focus:outline-none focus:!border-primary text-input sm:!text-lg text-sm !py-2 !px-2 sm:!py-3 sm:!px-4 ${isReadonlyName ? 'bg-gray-100 text-gray-600' : ''}`}
                            type={"text"}
                            name='name'
                            value={brokerName || ''}
                            readOnly={isReadonlyName}
                            onChange={(e) => setBrokerName(e.target.value)}
                            placeholder={'Enter Executive Name'}
                        />
                        {error && !brokerName && (
                            <div className="text-red sm:!text-sm text-xs !mt-2">Please Enter Executive Name</div>
                        )}
                    </div>
                    <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>Executive Mobile <sup className='text-red'>*</sup></label>
                        <div className='relative w-full'>
                            <PhoneInput
                                inputClass={'border !w-full focus:outline-none focus:!border-primary rounded-xl text-input !h-[38px] sm:!h-[54px] sm:!text-lg text-sm !py-2 sm:!py-3'}
                                country={'in'}
                                value={brokerMobile || ''}
                                countryCodeEditable={false}
                                enableSearch={true}
                                disableSearchIcon={true}
                                onChange={handleMobileChange}
                            />
                            {isVerifiedUser && (
                                <span className='absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-[#01AC47] text-white flex items-center justify-center text-xs font-bold shadow-xs pointer-events-none'>✓</span>
                            )}
                        </div>
                        {error && (!brokerMobile || (brokerMobile.replace(/\D/g, '').slice(-10).length === 0)) && (
                            <div className="text-red sm:!text-sm text-xs !mt-2">Please Enter Executive Mobile No.</div>
                        )}
                        {mobileError && (brokerMobile && brokerMobile.replace(/\D/g, '').slice(-10).length > 0 && brokerMobile.replace(/\D/g, '').slice(-10).length < 10) && <div className="text-red sm:!text-sm text-xs !mt-2">Please Enter Valid Mobile No.</div>}
                        {isVerifiedUser && (
                            <div className="!mt-1">
                                <span className="inline-flex items-center gap-1 bg-green-50 text-[#01AC47] text-xs font-semibold px-2.5 py-1 rounded-md">
                                    <span className="font-bold">✓</span> Verified in this firm
                                </span>
                            </div>
                        )}
                        {userNotFound && !isVerifiedUser && (
                            <div className="!mt-1">
                                <span className="inline-block bg-amber-100 text-amber-800 text-xs font-semibold px-2.5 py-1 rounded">
                                    Pending — sourcing person to verify
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Sourcing Manager (Full Width below Executive Name & Mobile) */}
                <div className='w-full flex flex-col font-medium relative'>
                    <label className='sm:!text-lg text-base !mb-2'>Sourcing Manager</label>
                    <div className="flex items-center gap-2 sm:gap-3 w-full">
                        <div className="flex-1 min-w-0">
                            <Select
                                isDisabled={!companyId}
                                options={companyId ? allSourcingManagers : []}
                                placeholder={companyId ? 'Select Sourcing Manager' : 'Select CP Firm first'}
                                styles={customStyles}
                                value={companyId ? sourcingManager : null}
                                onChange={(value) => {
                                    setSourcingManager && setSourcingManager(value ? resolveSourcingManagerOption(value, allSourcingManagers) : null);
                                    setSourcingManagerSource && setSourcingManagerSource('manual');
                                }}
                                isClearable={true}
                                noOptionsMessage={() => (companyId ? "No Sourcing Managers found" : "Please select a CP Firm first")}
                            />
                        </div>
                        <button
                            type="button"
                            onClick={fetchSourcingManagers}
                            disabled={!companyId || isSourcingRefreshing}
                            className="h-[44px] w-[44px] sm:h-[54px] sm:w-[54px] flex items-center justify-center rounded-xl border border-gray-300 bg-white hover:bg-gray-50 active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer flex-shrink-0"
                            title="Refresh sourcing managers list"
                        >
                            <RefreshIcon className={`w-5 h-5 text-gray-500 ${isSourcingRefreshing ? 'spin-animation' : ''}`} />
                        </button>
                    </div>
                </div>


                <div className='w-full sm:space-x-4 space-y-4 space-y-reverse sm:space-y-0 flex flex-col-reverse sm:flex-row !mt-6' >
                    <button className='w-full sm:w-1/2 text-base sm:!text-lg border rounded-xl !py-2 sm:!py-3.5' onClick={() => {
                        if (setCompanyId) setCompanyId('');
                        if (setBrokerName) setBrokerName('');
                        if (setBrokerMobile) setBrokerMobile('91');
                        if (setRera) setRera('');
                        if (setOwnerName) setOwnerName('');
                        if (setOwnerMobile) setOwnerMobile('91');
                        if (setCompanyName) setCompanyName('');
                        if (setCpContactUuid) setCpContactUuid(null);
                        clearCpFirmSourcingManager();
                        setChannelPartner('3');
                    }}>Back</button>
                    <button className='w-full sm:w-1/2 text-base sm:!text-lg rounded-xl !py-2 sm:!py-3.5 bg-blue-900 text-white' onClick={() => {
                        handleSubmit()
                    }}>Next</button>
                </div>
            </div>

            {/* RERA Duplicate Warning Modal matching tablet_form_cp_flow_mockup_2.html */}
            {showReraModal && (
                <div className='fixed inset-0 bg-[#101828]/45 flex items-center justify-center z-[9999] p-4 animate-in fade-in duration-150'>
                    <div className='bg-white border border-gray-200 border-t-[3px] border-t-[#FC5A5A] rounded-[10px] shadow-lg max-w-[400px] w-full p-6 text-gray-800 animate-in zoom-in-95 duration-150'>
                        <div className='flex items-center gap-3 mb-3'>
                            <div className='w-9 h-9 rounded-full bg-[#FC5A5A]/10 text-[#FC5A5A] flex items-center justify-center text-lg font-bold flex-shrink-0'>
                                &#9888;
                            </div>
                            <h3 className='text-base font-semibold text-[#FC5A5A] mb-0'>
                                RERA number already registered
                            </h3>
                        </div>
                        <p className='text-sm text-[#667085] mb-5 leading-[20px]'>
                            <strong className='font-semibold text-[#344054]'>{rera}</strong> is already registered to{' '}
                            <strong className='font-semibold text-[#344054]'>{reraModalFirmName || 'another firm'}</strong>. Each company must have a unique RERA number — please check the number and enter the correct one.
                        </p>
                        <div className='w-full'>
                            <button
                                type='button'
                                className='w-full bg-[#FC5A5A] hover:bg-[#e04848] text-white font-semibold px-5 py-2.5 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer shadow-xs text-center'
                                onClick={closeReraModal}
                            >
                                Change RERA Number
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* Confirmation modal when modifying RERA of an existing firm */}
            {showReraConfirmModal && (
                <div className='fixed inset-0 bg-[#101828]/45 flex items-center justify-center z-[9999] p-4 animate-in fade-in duration-150'>
                    <div className='bg-white border border-gray-200 border-t-[3px] border-t-amber-500 rounded-[12px] shadow-xl max-w-[420px] w-full p-6 text-gray-800 animate-in zoom-in-95 duration-150'>
                        <div className='flex items-center gap-3 mb-3 pb-3 border-b border-gray-100'>
                            <div className='w-9 h-9 rounded-full bg-[#FEF0C7] text-[#B54708] flex items-center justify-center text-lg font-bold flex-shrink-0 border border-[#FDB022]'>
                                &#9888;
                            </div>
                            <h3 className='text-base sm:text-lg font-semibold text-gray-900 mb-0'>
                                Updating RERA of existing firm
                            </h3>
                        </div>
                        <p className='text-sm text-gray-600 mb-5 leading-[22px]'>
                            You are changing the RERA number for existing firm <strong className='font-semibold text-gray-900'>{companyId?.label || companyId?.data?.name || 'this firm'}</strong> from <span className='font-mono bg-gray-100 px-1.5 py-0.5 rounded text-gray-800'>{initialRera || 'None'}</span> to <span className='font-mono bg-blue-50 text-blue-700 px-1.5 py-0.5 rounded font-semibold'>{rera}</span>. Are you sure you want to proceed?
                        </p>
                        <div className='flex items-center gap-3 w-full'>
                            <button
                                type='button'
                                className='w-1/2 py-2.5 text-sm font-medium text-gray-700 hover:text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer text-center'
                                onClick={() => setShowReraConfirmModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                type='button'
                                className='w-1/2 bg-[#0062FF] hover:bg-blue-700 text-white font-semibold py-2.5 rounded-lg text-sm transition-colors cursor-pointer shadow-xs text-center'
                                onClick={() => {
                                    setShowReraConfirmModal(false);
                                    handleSubmit();
                                }}
                            >
                                Yes, Proceed
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* {showQRCodeModal && <BorkerQRCode show={showQRCodeModal} setShowQRCodeModal={setShowQRCodeModal} setShowDetailModal={setShowDetailModal} closeModal={() => setShowQRCodeModal(false)} />}
            {showDetailModal && <GetBrokerCodeModal
                show={showDetailModal}
                setShowBrokerCodeModal={setShowBrokerCodeModal}
                closeModal={() => setShowDetailModal(false)}
            />}
            {showBrokerCodeModal && <BrokerCodeModal show={showBrokerCodeModal} closeModal={() => setShowBrokerCodeModal(false)} setChannelPartner={setChannelPartner} brokerCode={brokerCode} />} */}
        </div>
    )
}

export default BorkerDetailForm